<app-title-section></app-title-section>

<div class="card " style="margin-left: 15px; margin-right: 15px" #exportContainer>
    <!-- Tabs -->
    <div class="p-1 mt-1" style="margin-left: 20px">
<button (click)="retour() " class="unstyled-btn ">
    <i data-feather="arrow-left" [size]="18"> </i>
</button>
        Retour
    </div>

    <div class="cardBlue ">
        <div class="justify-content-start pt-3" >
            <p class="size18" style="padding-left: 63px;" >{{ soldeType === 'primaire' ? 'Solde primaire' : 'Solde secondaire' }} </p>
        </div>
        <div class="d-flex justify-content-end pt-1 pr-2">
            <div class="border-dashed rounded text-center total-box">
                <div class=" total-number">
                    {{ formatSoldeMontant() }} TND
                </div>
                <p class="size15">Total</p>
            </div>
        </div>
    </div>


<app-filtre-date (dateFilterChange)="onDateFilterChange($event)"></app-filtre-date>


    <div class="d-flex align-items-center flex-wrap" style="margin-top: 24px; margin-left: 44px; margin-right: 24px; gap: 12px;">
        <div class="d-flex align-items-center flex-wrap" style="gap: 12px;">
            <div class="input-group form-password-toggle d-flex" style="width: 300px;">
                <input
                        type="text"
                        class="form-control"
                        placeholder="Recherche par mot clé"
                        aria-label="Search..."
                        aria-describedby="basic-addon-search1"
                        [(ngModel)]="searchTerm" (ngModelChange)="onSearch()"
                />
                <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i data-feather="search" [size]="20"></i></span>
                </div>
            </div>
            <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
                <span data-feather="filter"></span>
            </button>
            <!-- Active Filters Chips -->
            <div class="d-flex align-items-center flex-wrap" style="gap: 8px;" *ngIf="activeFilters.length > 0">
                <div *ngFor="let filter of activeFilters; trackBy: trackByFilterKey" class="filter-chip">
                    <span class="filter-chip-label">{{ filter.label }}:</span>
                    <span class="filter-chip-value">{{ filter.value }}</span>
                    <button type="button" class="filter-chip-close" (click)="removeFilter(filter.key); $event.stopPropagation(); $event.preventDefault()" aria-label="Supprimer le filtre">
                        <i data-feather="x" [size]="14"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- Filter Panel -->
        <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 350px;">
            <div class="card-header d-flex justify-content-between align-items-center p-1" style="margin-top: 2px;">
                <h4 class="card-title mb-0">Filtres</h4>
                <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                    X <i class="bx bx-x"></i>
                </button>
            </div>
            <div class="card-body d-flex flex-column p-1" style="height: 350px; margin: 8px ; box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">
                <div class="flex-grow-1 overflow-auto pe-1">
                    <div class="mb-1">
                        <label class="form-label">Type d'opération</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.type_operation">
                                <option value="">Tous</option>
                                <option value="credit">Crédit</option>
                                <option value="debit">Débit</option>
                            </select>
                        </div>
                    </div>

                    <div class="mb-1">
                        <label class="form-label">Type de transaction</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.type_transaction">
                                <option value="">Tous</option>
                                <option value="paiement">Paiement</option>
                                <option value="remise_banque">Remise en banque</option>
                                <option value="operation_diverse">Opération diverse</option>
                                <option value="depense">Dépense</option>
                                <option value="annulation">Annulation</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">Mode de paiement</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.methode_paiement">
                                <option value="">Tous</option>
                                <option value="cheque">Chèque</option>
                                <option value="espece">Espèce</option>
                                <option value="virement">Virement</option>
                                <option value="traite">Traite</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">Catégories</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1 " [(ngModel)]="filters.categorie_id">
                                <option [value]="undefined">Tous</option>
                                <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.nom }}</option>
                            </select>

                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">Date de création (De)</label>
                        <input type="date" class="form-control mb-1" [(ngModel)]="filters.dateFrom"/>
                        <label class="form-label">Jusqu’a</label>
                        <input placeholder="jusqu’a" type="date" class="form-control" [(ngModel)]="filters.dateTo"/>
                    </div>
                </div>
                <div class="pt-2 d-flex justify-content-end gap-1">
                    <button class="btn btn-outline-secondary " (click)="resetFilters()" style="margin-right: 15px;">Réinitialiser</button>
                    <button class="btn btn-primary " (click)="applyFilters()">Appliquer</button>
                </div>
            </div>
        </div>

    </div>
    <div style=" border-bottom: 1px solid #eee; margin-top: 24px; margin-bottom: 10px"></div>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class=" custom-thead" >
            <tr  class="align-middle" >
                <th>Date</th>
                <th>Type</th>
                <th>TTC</th>
                <th>dOCUMENT</th>
                <th>débit / dépense</th>
                <th>Crédit / Recu</th>
                <th>ACTIONs</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="isLoading">
                <td colspan="7" class="text-center">
                    <p>Chargement...</p>
                </td>
            </tr>
            <tr *ngIf="!isLoading && items.length === 0">
                <td colspan="7" class="text-center">
                    <p>Aucune opération trouvée</p>
                </td>
            </tr>
            <tr *ngFor="let item of items.slice((currentPage - 1) * perPage, currentPage * perPage)">
                <td [size]="15">{{ item.date }}</td>
                <td [size]="15">{{ item.type }}</td>
                <td [size]="15">{{ item.ttc }} <br> <p class="text-muted">{{ item.document }}</p></td>
                <td [size]="15">{{ item.document }}</td>
                <td [size]="15"> <span class="debit">{{ item.debit }} </span> </td>
                <td [size]="15" > <span class="credit">{{ item.credit }} </span></td>
                <td>
                    <div class="d-flex align-items-center action-icon gap-1">
                        <button type="button" class="unstyled-btn" (click)="deleteTresorerie(item); $event.stopPropagation()" title="Supprimer l'opération">
                            <i data-feather="trash-2" [size]="'20'" class="cursor-pointer text-danger icon-trash-20"></i>
                        </button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="row mt-3">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center" style="font-size: 15px;">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="updatePagination()">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«</div>
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(currentPage - 1)">‹</div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage" (click)="changePage(page)">{{ page }}</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(currentPage + 1)">›</div>
                <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(totalPages)">»</div>
            </div>
        </div>
    </div>
</div>

<app-save #save (operationCreated)="onOperationCreated()"></app-save>
